/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest,
  DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationResponse,
  DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidPathParams,
  DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid400,
  DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid401,
  DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid404,
  DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid500,
} from "../../types/classPlanningGradeAndFrequenceConfigurationController/DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { deleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid } from "../../clients/classPlanningGradeAndFrequenceConfigurationController/deleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid.ts";

export const deleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationKey =
  () =>
    [
      {
        url: "/api/v1/classroomdiscipline/grade-and-frequence/class-modules/:classModuleId",
      },
    ] as const;

export type DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationKey =
  ReturnType<
    typeof deleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationKey
  >;

export function deleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey =
    deleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationKey();
  return mutationOptions<
    DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid400
      | DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid401
      | DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid404
      | DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid500
    >,
    {
      classModuleId: DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidPathParams["classModuleId"];
      data?: DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ classModuleId, data }) => {
      return deleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid(
        classModuleId,
        data,
        config,
      );
    },
  });
}

/**
 * @description Remove o vínculo das Aulas informadas com o Módulo. Aulas que não pertencem ao Módulo são ignoradas. **(Requer Authorization para autenticação)**
 * @summary Desanexar Aulas do Módulo (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/grade-and-frequence/class-modules/:classModuleId}
 */
export function useDeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationResponse,
      ResponseErrorConfig<
        | DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid400
        | DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid401
        | DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid404
        | DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid500
      >,
      {
        classModuleId: DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidPathParams["classModuleId"];
        data?: DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationKey();

  const baseOptions =
    deleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationResponse,
      ResponseErrorConfig<
        | DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid400
        | DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid401
        | DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid404
        | DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid500
      >,
      {
        classModuleId: DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidPathParams["classModuleId"];
        data?: DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest;
      },
      TContext
    >;

  return useMutation<
    DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid400
      | DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid401
      | DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid404
      | DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid500
    >,
    {
      classModuleId: DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidPathParams["classModuleId"];
      data?: DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid400
      | DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid401
      | DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid404
      | DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid500
    >,
    {
      classModuleId: DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidPathParams["classModuleId"];
      data?: DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest;
    },
    TContext
  >;
}
